export const selectCurrentTheme = (state) => state.theme?.theme;
